<template>
  <Dialog
    custom-class="pg-dialog-select-stock pg-dialog"
    top=""
    :showClose="showClose"
    :closeOnClickModal="closeOnClickModal"
    :closeOnPressEscape="closeOnPressEscape"
    :title="title"
    :visible="showDrawer"
    :modal="modal"
    :before-close="onCancel"
    :append-to-body="appendToBody"
    :width="width"
    @close="close"
    @closed="closed"
    @open="open"
  >
    <div class="pg-dialog-select-stock__content">
      <PgForm
        v-if="!!model"
        class="pg-dialog-select-stock__content-form"
        :formItems="formItems"
        :formItemsCode="formItemsCode"
        :model="model"
      >
      </PgForm>
      <div class="pg-dialog-select-stock__content-btn">
        <ElButton
          type="primary"
          size="small"
          round
          icon="ivu-icon-icon-pg-qk"
          @click="outStorageMode('NEFO')"
          >近效先出</ElButton
        >
        <ElButton
          type="primary"
          size="small"
          round
          icon="ivu-icon-icon-pg-qk"
          @click="outStorageMode('FIFO')"
          >先进先出</ElButton
        >
        <ElButton type="danger" size="small" round icon="ivu-icon-icon-pg-qk" @click="clearAmount"
          >清空数量</ElButton
        >
      </div>
      <PgTable
        ref="tableRef"
        class="pg-dialog-select-stock__content-table"
        seqShow
        height="auto"
        :loading="loading"
        :rowConfig="{ height: 48 }"
        :columnTableCode="columnTableCode"
        :isIconSelection="false"
        :isSelection="false"
        :pageSize="page.pageSize"
        :pageSizes="[30, 5, 100, 200]"
        :current-page="page.pageNo"
        :showPagination="showPagination"
        @size-change="sizeChange"
        @current-change="currentChange"
      ></PgTable>
    </div>
    <template #footer>
      <slot name="footer">
        <ElButton
          style="min-width: 120px"
          type="primary"
          round
          @click="submit"
          :loading="sureLoading"
        >
          确定
        </ElButton>
      </slot>
    </template>
  </Dialog>
</template>
<script setup>
import { Dialog } from 'element-ui'
import { useDrawerPack } from '../../../hooks/index'
import { PgTable } from '../../table/index'
import { PgForm } from '../../form/index'
import { toRefs, ref, reactive } from 'vue'
import { pgMessageBox } from '../../message-box/index'

const props = defineProps({
  showClose: {
    type: Boolean,
    default: true,
  },
  closeOnClickModal: {
    type: Boolean,
    default: true,
  },
  closeOnPressEscape: {
    type: Boolean,
    default: true,
  },
  appendToBody: {
    type: Boolean,
    default: true,
  },
  visible: {
    type: Boolean,
    default: true,
  },
  modal: {
    type: Boolean,
    default: true,
  },
  title: {
    type: String,
    default: '库存选择',
  },
  width: {
    type: String,
    default: '1200px',
  },
  formItems: [Array, Object],
  formItemsCode: String,
  model: Object,
  columnTableCode: String,
  showPagination: { type: Boolean, default: false },
  data: [Array, Function],
})

const emit = defineEmits(['update:visible', 'close', 'closed', 'on-cancel', 'on-ok'])

const { visible } = toRefs(props)
const { showDrawer, close, closed, onCancel, closeDrawer } = useDrawerPack(visible, emit)

const loading = ref(false)
const page = reactive({
  pageNo: 1,
  pageSize: 50,
})
const tableRef = ref(null)
const getData = async (outStorageMode) => {
  loading.value = true
  if (typeof props.data === 'function') {
    const resData = await props.data(outStorageMode)
    tableRef.value.loadData(resData)
  }
  loading.value = false
}
const outStorageMode = (outStorageMode) => {
  getData(outStorageMode)
}
const open = () => {
  getData()
}
const sizeChange = (pageSize) => {
  console.log('sizeChange', pageSize)
}
const currentChange = (pageNo) => {
  console.log('currentChange', pageNo)
}

const sureLoading = ref(false)
const submit = async () => {
  const { fullData } = tableRef.value.getTableData()
  const tableData = fullData.filter((im) => {
    im.goodsKeeping.storageItemId = im.id
    return im.amountOut > 0
  })
  const totalAmount = tableData.reduce((total, item) => {
    return total + item.amountOut
  }, 0)
  if (totalAmount > props.model.amount) {
    pgMessageBox({
      message: '数量与计划数量不一致',
    })
  } else {
    emit('on-ok', tableData)
    closeDrawer()
  }
}
const clearAmount = () => {
  const { fullData } = tableRef.value.getTableData()
  fullData.forEach((item) => {
    item.amountOut = 0
  })
  tableRef.value.loadData(fullData)
}
</script>
<style lang="scss">
@import '../style/select-stock.scss';
</style>
